import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Error404 from 'src/app/components/Error404';
import usePermission from '@/app/hooks/usePermission';
import CourseAdminCard from './course-admin-card';
import { Link } from 'react-router-dom';
import { useCourse } from 'src/app/hooks/useCourse';
import { useClassroom } from 'src/app/hooks/useClassroom';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import { CourseAdminAboutModalClassroom } from './course-admin-about/course-admin-about-modal-classroom';
import { CourseAdminAboutModalModule } from './course-admin-about/course-admin-about-modal-module';
import { Button } from '@/components/ui/button';
import { DashboardContent } from '@/layouts/dashboard';
import { Filter, FilterActions, FilterContent, FilterInput } from '@/components/custom/filter';
import { CourseCardAdminWrapper } from '@/components/custom/course';

export function CourseAdmin(props) {
  const { uri } = props;

  const filters = useFormik({
    initialValues: {
      searchTerm: ''
    }
  });

  const { detailedCourses, loading, getDetailedCourses } = useCourse();
  const { detailedClassrooms: classrooms, getDetailedClassrooms, classroomLoading, getCourseModules, courseModules, modulesLoading } = useClassroom();
  const [filteredClassrooms, setFilteredClassrooms] = useState([]);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [showClassroomModal, setShowClassroomModal] = useState(false);
  const [activeCourse, setActiveCourse] = useState();
  const [filteredCourses, setFilteredCourses] = useState();

  const viewCourse = usePermission('Visualizar lista de cursos', 'Cursos');

  const handleOpenClassroomModal = course => {
    getDetailedClassrooms(course.id);
    setActiveCourse(course);
    setShowClassroomModal(true);
  };

  const handleOpenModulesModal = async course => {
    await getCourseModules(course.id);
    if (!modulesLoading) {
      setActiveCourse(course);
      setShowModuleModal(true);
    }
  };

  useEffect(() => {
    getDetailedCourses();
  }, []);

  useEffect(() => {
    if (classrooms) {
      setFilteredClassrooms(classrooms);
    }
  }, [classrooms]);

  useEffect(() => {
    if (detailedCourses.length > 0) {
      const filteredCourses = detailedCourses.filter(item => {
        const searchTermFilter = filters.values.searchTerm === '' ? true : item.title !== null && item.title.toLowerCase().includes(filters.values.searchTerm.toLowerCase());
        return searchTermFilter;
      });
      setFilteredCourses(filteredCourses);
    }
  }, [filters.values, detailedCourses]);

  const breadcrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Cursos',
        isActive: true
      }
    ]
  };

  if (!viewCourse) return <Error404 />;

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <Filter>
        <FilterContent>
          <FilterInput
            label={t('textsCommon.research')}
            placeholder={t('filter.courseName')}
            type="search"
            name="search"
            value={filters.values.searchTerm}
            onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
          />
        </FilterContent>

        {usePermission('Criar cursos', 'Cursos') && (
          <FilterActions>
            <Button
              size="sm"
              wide
              asChild
            >
              <Link to={`/curso/criar/sobre`}>{t('courses.buttonNewCourse')}</Link>
            </Button>
          </FilterActions>
        )}
      </Filter>

      {!filteredCourses && loading && <Loader />}
      {!loading && filteredCourses && filteredCourses?.length === 0 && <EmptyState type="data" />}

      <CourseCardAdminWrapper>
        {filteredCourses?.map(item => {
          return (
            <CourseAdminCard
              classroomLoading={classroomLoading}
              setFilteredCourses={setFilteredCourses}
              classrooms={classrooms}
              handleOpenClassroomModal={handleOpenClassroomModal}
              handleOpenModulesModal={handleOpenModulesModal}
              key={item.id}
              course={item}
            />
          );
        })}
      </CourseCardAdminWrapper>

      <CourseAdminAboutModalClassroom
        classroomLoading={classroomLoading}
        classrooms={filteredClassrooms}
        course={activeCourse}
        show={showClassroomModal}
        onClose={() => setShowClassroomModal(false)}
      />

      <CourseAdminAboutModalModule
        courseModules={courseModules}
        course={activeCourse}
        show={showModuleModal}
        onClose={() => setShowModuleModal(false)}
      />
    </DashboardContent>
  );
}
